<template>
  <div class="backend">
    <div class="side">
      <el-tabs tab-position="left" class="demo-tabs" @tab-change="handleTabChange" v-model="activeTab">
        <template v-for="item in panes" :key="item.type">
          <el-tab-pane  :label="item.label" :name="item.type"></el-tab-pane>
      </template>
        </el-tabs>
    </div>
    <div class="main-con">
      <div class="yingyong">
        <el-select v-model="lang" placeholder="请选择类型" @change="handleLangChange">
          <el-option label="中文" value="1" />
          <el-option label="英文" value="2" />
        </el-select>
        <!-- <div class="search">
          <el-input
            v-model="queryParams.searchText"
            placeholder="请输入搜索内容"
            clearable
            style="width: 300px"
          />
          <el-button type="primary" @click="handleSearch">搜索</el-button>
      </div> -->
      </div>
      <div class="pro-con" v-show="activeTab == 'product'">
        <div class="pro-top">
          <el-button type="primary" @click="handleProductAdd">添加</el-button>
          </div>
          <div class="table-wrap">
            <el-table
            :data="tableData"
            style="width: 100%;flex: 1; "

          >
            <el-table-column prop="name" label="名称" align="left" class-name="text-column" show-overflow-tooltip/>
            <el-table-column prop="sort" label="排序" align="center" class-name="text-column" width="80"/>
            <el-table-column prop="banner" label="banner" align="center" class-name="image-column">
             <template #default="scope">
                <img :src="scope.row.banner" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="mbanner" label="移动端banner" align="center" class-name="image-column">
             <template #default="scope">
                <img :src="scope.row.mbanner" style="width: 100px;" alt="图片预览" />
            </template>
            </el-table-column>
            <el-table-column prop="thumbnail" label="缩略图" align="center" class-name="image-column">
              <template #default="scope">
                <img
                  :src="scope.row.thumbnail"
                  style="width: 100px;"
                  alt="图片预览"
                  />
              </template>
            </el-table-column>
            <el-table-column prop="description" label="产品描述" align="center" class-name="multiline-column" show-overflow-tooltip/>
            <el-table-column label="操作" align="right" class-name="action-column">
              <template #default="scope">
                <el-button size="small" type="success" @click="handleProductEdit(scope.row.id)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleProductDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total > 0"
            :total="total"
            v-model:page="queryParams.current"
            v-model:limit="queryParams.size"
            @pagination="Detailgender"
          />
          </div>
        <el-dialog v-model="dialogVisible" :title="productIsEdit ? '编辑产品' : '添加产品'" width="70%" @close="handleProductDialogClose">
          <el-form :model="fullform" label-width="100px" class="news-form">
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item label="产品名称">
                  <el-input v-model="fullform.name" placeholder="请输入产品名称" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="排序">
                  <el-input-number v-model="fullform.sort" :min="0" placeholder="请输入排序号" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Banner">
                  <el-upload
                    :http-request="(options) => handleBannerUpload(options)"
                    :file-list="bannerFileList"
                    list-type="picture-card"
                    :on-remove="handleBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="MBanner">
                  <el-upload
                    :http-request="(options) => handlemBannerUpload(options)"
                    :file-list="mbannerFileList"
                    list-type="picture-card"
                    :on-remove="handlemBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="缩略图">
                  <el-upload
                    :http-request="(options) => handleThumbUpload(options)"
                    :file-list="thumbnailFileList"
                    list-type="picture-card"
                    :on-remove="handleThumbRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="产品简介">
              <el-input type="textarea" v-model="fullform.description" placeholder="请输入产品简介" :rows="3" />
            </el-form-item>

            <el-form-item label="关联案例">
              <el-select
                v-model="fullform.caseIds"
                multiple
                placeholder="请选择关联案例"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in caseList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="产品正文">
              <div style="border: 1px solid #dcdfe6; width: 100%">
                <Toolbar
                  :editor="productEditorRef"
                  :defaultConfig="toolbarConfig"
                  mode="default"
                  style="border-bottom: 1px solid #dcdfe6"
                />
                <Editor
                  v-model:html="productEditorContent"
                  :defaultConfig="productEditorConfig"
                  mode="default"
                  style="height: 400px; overflow-y: hidden"
                  @onCreated="handleProductEditorCreated"
                />
              </div>
            </el-form-item>

      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="productIsEdit ? handleProductConfirmEdit() : handleProductConfirmAdd()">确认</el-button>
      </template>
    </el-dialog>
      </div>
      <div class="sol-con" v-show="activeTab == 'solution'">
        <div class="pro-top">
          <el-button type="primary" @click="handleSolutionAdd">添加</el-button>
          </div>
          <div class="table-wrap">
            <el-table
            :data="tableData"
            style="width: 100%;flex: 1; "

          >
            <el-table-column prop="name" label="名称" align="left" class-name="text-column" show-overflow-tooltip/>
            <el-table-column prop="sort" label="排序" align="center" class-name="text-column" width="80"/>
            <el-table-column prop="banner" label="banner" align="center" class-name="image-column">
             <template #default="scope">
                <img :src="scope.row.banner" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="mbanner" label="移动端banner" align="center" class-name="image-column">
             <template #default="scope">
                <img :src="scope.row.mbanner" style="width: 100px;" alt="图片预览" />
            </template>
            </el-table-column>
            <el-table-column prop="thumbnail" label="缩略图" align="center" class-name="image-column">
              <template #default="scope">
                <img
                  :src="scope.row.thumbnail"
                  style="width: 100px;"
                  alt="图片预览"
                  />
              </template>
            </el-table-column>
            <el-table-column prop="description" label="解决方案描述" align="center" class-name="multiline-column" show-overflow-tooltip/>
            <el-table-column label="操作" align="right" class-name="action-column">
              <template #default="scope">
                <el-button size="small" type="success" @click="handleSolutionEdit(scope.row.id)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleSolutionDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total > 0"
            :total="total"
            v-model:page="queryParams.current"
            v-model:limit="queryParams.size"
            @pagination="Detailgender"
          />
          </div>
        <el-dialog v-model="dialogVisible" :title="solutionIsEdit ? '编辑解决方案' : '添加解决方案'" width="70%" @close="handleSolutionDialogClose">
          <el-form :model="fullform" label-width="100px" class="news-form">
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item label="解决方案名称">
                  <el-input v-model="fullform.name" placeholder="请输入解决方案名称" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="排序">
                  <el-input-number v-model="fullform.sort" :min="0" placeholder="请输入排序号" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Banner">
                  <el-upload
                    :http-request="(options) => handleBannerUpload(options)"
                    :file-list="bannerFileList"
                    list-type="picture-card"
                    :on-remove="handleBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="MBanner">
                  <el-upload
                    :http-request="(options) => handlemBannerUpload(options)"
                    :file-list="mbannerFileList"
                    list-type="picture-card"
                    :on-remove="handlemBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="缩略图">
                  <el-upload
                    :http-request="(options) => handleThumbUpload(options)"
                    :file-list="thumbnailFileList"
                    list-type="picture-card"
                    :on-remove="handleThumbRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="解决方案简介">
              <el-input type="textarea" v-model="fullform.description" placeholder="请输入解决方案简介" :rows="3" />
            </el-form-item>

            <el-form-item label="解决方案正文">
              <div style="border: 1px solid #dcdfe6; width: 100%">
                <Toolbar
                  :editor="solutionEditorRef"
                  :defaultConfig="toolbarConfig"
                  mode="default"
                  style="border-bottom: 1px solid #dcdfe6"
                />
                <Editor
                  v-model:html="solutionEditorContent"
                  :defaultConfig="solutionEditorConfig"
                  mode="default"
                  style="height: 400px; overflow-y: hidden"
                  @onCreated="handleSolutionEditorCreated"
                />
              </div>
            </el-form-item>

      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="solutionIsEdit ? handleSolutionConfirmEdit() : handleSolutionConfirmAdd()">确认</el-button>
      </template>
    </el-dialog>
      </div>
      <div class="case-con" v-show="activeTab == 'case'">
        <div class="pro-top">
          <el-button type="primary" @click="handleCaseAdd">添加</el-button>
          </div>
          <div class="table-wrap">
            <el-table
            :data="tableData"
            style="width: 100%;flex: 1; "

          >
            <el-table-column prop="name" label="名称" align="left" class-name="text-column" show-overflow-tooltip/>
            <el-table-column prop="sort" label="排序" align="center" class-name="text-column" width="80"/>
            <el-table-column prop="banner" label="banner" align="center" class-name="image-column">
             <template #default="scope">
                <img :src="scope.row.banner" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="mbanner" label="移动端banner" align="center" class-name="image-column">
             <template #default="scope">
                <img :src="scope.row.mbanner" style="width: 100px;" alt="图片预览" />
            </template>
            </el-table-column>
            <el-table-column prop="thumbnail" label="缩略图" align="center" class-name="image-column">
              <template #default="scope">
                <img
                  :src="scope.row.thumbnail"
                  style="width: 100px;"
                  alt="图片预览"
                  />
              </template>
            </el-table-column>
            <el-table-column prop="description" label="案例描述" align="center" class-name="multiline-column" show-overflow-tooltip/>
            <el-table-column label="操作" align="right" class-name="action-column">
              <template #default="scope">
                <el-button size="small" type="success" @click="handleCaseEdit(scope.row.id)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleCaseDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total > 0"
            :total="total"
            v-model:page="queryParams.current"
            v-model:limit="queryParams.size"
            @pagination="Detailgender"
          />
          </div>
        <el-dialog v-model="dialogVisible" :title="caseIsEdit ? '编辑案例' : '添加案例'" width="70%" @close="handleCaseDialogClose">
          <el-form :model="fullform" label-width="100px" class="news-form">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="案例标题">
                  <el-input v-model="fullform.name" placeholder="请输入案例标题" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="排序">
                  <el-input-number v-model="fullform.sort" :min="0" placeholder="请输入排序号" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Banner">
                  <el-upload
                    :http-request="(options) => handleBannerUpload(options)"
                    :file-list="bannerFileList"
                    list-type="picture-card"
                    :on-remove="handleBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="MBanner">
                  <el-upload
                    :http-request="(options) => handlemBannerUpload(options)"
                    :file-list="mbannerFileList"
                    list-type="picture-card"
                    :on-remove="handlemBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="缩略图">
                  <el-upload
                    :http-request="(options) => handleThumbUpload(options)"
                    :file-list="thumbnailFileList"
                    list-type="picture-card"
                    :on-remove="handleThumbRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="案例简介">
              <el-input type="textarea" v-model="fullform.description" placeholder="请输入案例简介" :rows="3" />
            </el-form-item>

            <el-form-item label="案例正文">
              <div style="border: 1px solid #dcdfe6; width: 100%">
                <Toolbar
                  :editor="caseEditorRef"
                  :defaultConfig="toolbarConfig"
                  mode="default"
                  style="border-bottom: 1px solid #dcdfe6"
                />
                <Editor
                  v-model:html="caseEditorContent"
                  :defaultConfig="caseEditorConfig"
                  mode="default"
                  style="height: 400px; overflow-y: hidden"
                  @onCreated="handleCaseEditorCreated"
                />
              </div>
            </el-form-item>

      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="caseIsEdit ? handleCaseConfirmEdit() : handleCaseConfirmAdd()">确认</el-button>
      </template>
    </el-dialog>
      </div>

      <div class="device-con" v-show="activeTab == 'device'">
        <div class="pro-top">
          <el-button type="primary" @click="handleDeviceAdd">添加</el-button>
          </div>
          <div class="table-wrap">
            <el-table
            :data="tableData"
            style="width: 100%;flex: 1; "

          >
            <el-table-column prop="name" label="名称" align="left" class-name="text-column" show-overflow-tooltip/>
            <el-table-column label="所属设备类型" align="center" class-name="text-column" show-overflow-tooltip>
              <template #default="scope">
                {{ getDeviceTypeName(scope.row.deviceTypeId) }}
              </template>
            </el-table-column>
            <el-table-column prop="sort" label="排序" align="center" class-name="text-column" width="80"/>
            <el-table-column prop="banner" label="banner1" align="center" class-name="image-column">
             <template #default="scope">
                <video v-if="isVideoFile(scope.row.banner)" :src="scope.row.banner" preload="metadata" muted style="width:100px;height:56px;object-fit:cover;"></video>
                <img v-else :src="scope.row.banner" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="banner2" label="banner2" align="center" class-name="image-column">
             <template #default="scope">
                <video v-if="isVideoFile(scope.row.banner2)" :src="scope.row.banner2" preload="metadata" muted style="width:100px;height:56px;object-fit:cover;"></video>
                <img v-else :src="scope.row.banner2" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="banner3" label="banner3" align="center" class-name="image-column">
             <template #default="scope">
                <video v-if="isVideoFile(scope.row.banner3)" :src="scope.row.banner3" preload="metadata" muted style="width:100px;height:56px;object-fit:cover;"></video>
                <img v-else :src="scope.row.banner3" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="thumbnail" label="缩略图" align="center" class-name="image-column">
              <template #default="scope">
                <img
                  :src="scope.row.thumbnail"
                  style="width: 100px;"
                  alt="图片预览"
                  />
              </template>
            </el-table-column>
            <el-table-column prop="description" label="设备描述" align="center" class-name="multiline-column" show-overflow-tooltip/>
            <el-table-column label="操作" align="right" class-name="action-column">
              <template #default="scope">
                <el-button size="small" type="success" @click="handleDeviceEdit(scope.row.id)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleDeviceDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total > 0"
            :total="total"
            v-model:page="queryParams.current"
            v-model:limit="queryParams.size"
            @pagination="Detailgender"
          />
          </div>
        <el-dialog v-model="dialogVisible" :title="deviceIsEdit ? '编辑设备' : '添加设备'" width="70%" @close="handleDeviceDialogClose">
          <el-form :model="fullform" label-width="100px" class="news-form">
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="设备名称">
                  <el-input v-model="fullform.name" placeholder="请输入设备名称" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="设备类型">
                  <el-select v-model="fullform.deviceTypeId" placeholder="请选择设备类型" clearable>
                    <el-option v-for="item in deviceTypeList" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="排序">
                  <el-input-number v-model="fullform.sort" :min="0" placeholder="排序号" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Banner1">
                  <el-upload
                    :http-request="(options) => handleBannerUpload(options)"
                    :file-list="bannerFileList"
                    list-type="picture-card"
                    :on-remove="handleBannerRemove"
                    :limit="1"
                    accept="image/*,video/*"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Banner2">
                  <el-upload
                    :http-request="(options) => handleDeviceBanner2Upload(options)"
                    :file-list="deviceBanner2FileList"
                    list-type="picture-card"
                    :on-remove="handleDeviceBanner2Remove"
                    :limit="1"
                    accept="image/*,video/*"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="Banner3">
                  <el-upload
                    :http-request="(options) => handleDeviceBanner3Upload(options)"
                    :file-list="deviceBanner3FileList"
                    list-type="picture-card"
                    :on-remove="handleDeviceBanner3Remove"
                    :limit="1"
                    accept="image/*,video/*"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20" v-if="fullform.banner || fullform.banner2 || fullform.banner3">
              <el-col :span="8">
                <div v-if="fullform.banner" class="banner-preview">
                  <video v-if="isVideoFile(fullform.banner)" :src="fullform.banner" preload="metadata" controls style="width:100%;max-height:200px;"></video>
                  <img v-else :src="fullform.banner" style="width:100%;max-height:200px;object-fit:contain;">
                </div>
              </el-col>
              <el-col :span="8">
                <div v-if="fullform.banner2" class="banner-preview">
                  <video v-if="isVideoFile(fullform.banner2)" :src="fullform.banner2" preload="metadata" controls style="width:100%;max-height:200px;"></video>
                  <img v-else :src="fullform.banner2" style="width:100%;max-height:200px;object-fit:contain;">
                </div>
              </el-col>
              <el-col :span="8">
                <div v-if="fullform.banner3" class="banner-preview">
                  <video v-if="isVideoFile(fullform.banner3)" :src="fullform.banner3" preload="metadata" controls style="width:100%;max-height:200px;"></video>
                  <img v-else :src="fullform.banner3" style="width:100%;max-height:200px;object-fit:contain;">
                </div>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="缩略图">
                  <el-upload
                    :http-request="(options) => handleThumbUpload(options)"
                    :file-list="thumbnailFileList"
                    list-type="picture-card"
                    :on-remove="handleThumbRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="设备简介">
              <el-input type="textarea" v-model="fullform.description" placeholder="请输入设备简介" :rows="3" />
            </el-form-item>

            <el-form-item label="关联设备">
              <el-select
                v-model="fullform.deviceIds"
                multiple
                placeholder="请选择关联设备"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in deviceList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="设备正文">
              <div style="border: 1px solid #dcdfe6; width: 100%">
                <Toolbar
                  :editor="deviceEditorRef"
                  :defaultConfig="toolbarConfig"
                  mode="default"
                  style="border-bottom: 1px solid #dcdfe6"
                />
                <Editor
                  v-model:html="deviceEditorContent"
                  :defaultConfig="deviceEditorConfig"
                  mode="default"
                  style="height: 400px; overflow-y: hidden"
                  @onCreated="handleDeviceEditorCreated"
                />
              </div>
            </el-form-item>

      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="deviceIsEdit ? handleDeviceConfirmEdit() : handleDeviceConfirmAdd()">确认</el-button>
      </template>
    </el-dialog>
      </div>
      <div class="device-type-con" v-show="activeTab == 'deviceType'">
        <div class="pro-top">
          <el-button type="primary" @click="handleDeviceTypeAdd">添加</el-button>
        </div>
        <div class="table-wrap">
          <el-table :data="tableData" style="width: 100%;flex: 1;">
            <el-table-column prop="name" label="类型名称" align="left" class-name="text-column" show-overflow-tooltip/>
            <el-table-column prop="sort" label="排序" align="center" class-name="text-column" width="80"/>
            <el-table-column prop="banner" label="banner" align="center" class-name="image-column">
              <template #default="scope">
                <img :src="scope.row.banner" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="mbanner" label="移动端banner" align="center" class-name="image-column">
              <template #default="scope">
                <img :src="scope.row.mbanner" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="thumbnail" label="缩略图" align="center" class-name="image-column">
              <template #default="scope">
                <img :src="scope.row.thumbnail" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="description" label="类型描述" align="center" class-name="multiline-column" show-overflow-tooltip/>
            <el-table-column label="操作" align="right" class-name="action-column">
              <template #default="scope">
                <el-button size="small" type="success" @click="handleDeviceTypeEdit(scope.row.id)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleDeviceTypeDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total > 0"
            :total="total"
            v-model:page="queryParams.current"
            v-model:limit="queryParams.size"
            @pagination="Detailgender"
          />
        </div>
        <el-dialog v-model="deviceTypeDialogVisible" :title="deviceTypeIsEdit ? '编辑硬件设备类型' : '添加硬件设备类型'" width="70%" @close="handleDeviceTypeDialogClose">
          <el-form :model="deviceTypeForm" label-width="100px" class="news-form">
            <el-row :gutter="20">
              <el-col :span="16">
                <el-form-item label="类型名称">
                  <el-input v-model="deviceTypeForm.name" placeholder="请输入类型名称" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="排序">
                  <el-input-number v-model="deviceTypeForm.sort" :min="0" placeholder="请输入排序号" style="width: 100%" />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Banner">
                  <el-upload
                    :http-request="(options) => handleDeviceTypeBannerUpload(options)"
                    :file-list="deviceTypeBannerFileList"
                    list-type="picture-card"
                    :on-remove="handleDeviceTypeBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="MBanner">
                  <el-upload
                    :http-request="(options) => handleDeviceTypeMBannerUpload(options)"
                    :file-list="deviceTypeMBannerFileList"
                    list-type="picture-card"
                    :on-remove="handleDeviceTypeMBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="缩略图">
                  <el-upload
                    :http-request="(options) => handleDeviceTypeThumbUpload(options)"
                    :file-list="deviceTypeThumbnailFileList"
                    list-type="picture-card"
                    :on-remove="handleDeviceTypeThumbRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="类型简介">
              <el-input type="textarea" v-model="deviceTypeForm.description" placeholder="请输入类型简介" :rows="3" />
            </el-form-item>

            <el-form-item label="类型正文">
              <div style="border: 1px solid #dcdfe6; width: 100%">
                <Toolbar
                  :editor="deviceTypeEditorRef"
                  :defaultConfig="toolbarConfig"
                  mode="default"
                  style="border-bottom: 1px solid #dcdfe6"
                />
                <Editor
                  v-model:html="deviceTypeEditorContent"
                  :defaultConfig="deviceTypeEditorConfig"
                  mode="default"
                  style="height: 400px; overflow-y: hidden"
                  @onCreated="handleDeviceTypeEditorCreated"
                />
              </div>
            </el-form-item>

          </el-form>
          <template #footer>
            <el-button @click="deviceTypeDialogVisible = false">取消</el-button>
            <el-button type="primary" @click="deviceTypeIsEdit ? handleDeviceTypeConfirmEdit() : handleDeviceTypeConfirmAdd()">确认</el-button>
          </template>
        </el-dialog>
      </div>
      <div class="news-con" v-show="activeTab == 'new'">
        <div class="pro-top">
          <el-button type="primary" @click="handleAdd">添加</el-button>
          </div>
          <div class="table-wrap">
            <el-table
            :data="tableData"
            style="width: 100%;flex: 1; "
            
          >
            <el-table-column prop="name" label="名称" align="left" class-name="text-column" show-overflow-tooltip/>
            <el-table-column prop="newsTime" label="发布时间" align="center" class-name="text-column">
              <template #default="scope">
                {{ formatNewsTime(scope.row.newsTime) }}
              </template>
            </el-table-column>
            <el-table-column prop="banner" label="banner" align="center" class-name="image-column">
             <template #default="scope">
                <img :src="scope.row.banner" style="width: 100px;" alt="图片预览" />
              </template>
            </el-table-column>
            <el-table-column prop="mbanner" label="移动端banner" align="center" class-name="image-column">
             <template #default="scope">
                <img :src="scope.row.mbanner" style="width: 100px;" alt="图片预览" />
            </template>
            </el-table-column>
            <el-table-column prop="thumbnail" label="缩略图" align="center" class-name="image-column">
              <template #default="scope">
                <img
                  :src="scope.row.thumbnail"
                  style="width: 100px;"
                  alt="图片预览"
                  />
              </template>
            </el-table-column>
            <el-table-column prop="description" label="新闻描述" align="center" class-name="multiline-column" show-overflow-tooltip/>
            <el-table-column label="置顶" align="center" width="80">
              <template #default="scope">
                <el-tag v-if="scope.row.top === 1" type="warning" size="small">已置顶</el-tag>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="right" class-name="action-column">
              <template #default="scope">
                <el-button size="small" type="primary" @click="handleSetNewsTop(scope.row.id)">置顶</el-button>
                <el-button size="small" type="success" @click="handleEditNews(scope.row.id)">编辑</el-button>
                <el-button size="small" type="danger" @click="handleDeleteNews(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <pagination
            v-show="total > 0"
            :total="total"
            v-model:page="queryParams.current"
            v-model:limit="queryParams.size"
            @pagination="Detailgender"
          />
          </div>
        <el-dialog v-model="dialogVisible" :title="isEdit ? '编辑新闻' : '添加新闻'" width="70%" @close="handleNewsDialogClose">
          <el-form :model="fullform" label-width="100px" class="news-form">
            <!-- Row 1: 新闻标题 + 新闻简称 + 发布时间 -->
            <el-row :gutter="20">
              <el-col :span="10">
                <el-form-item label="新闻标题">
                  <el-input v-model="fullform.name" placeholder="请输入新闻标题" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="发布时间">
                  <el-date-picker
                    v-model="fullform.newsTime"
                    type="datetime"
                    placeholder="选择日期和时间"
                    style="width: 100%"
                    value-format="YYYY-MM-DD HH:mm:ss"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- Row 2: 三个图片上传 -->
            <el-row :gutter="20">
              <el-col :span="8">
                <el-form-item label="Banner">
                  <el-upload
                    :http-request="(options) => handleBannerUpload(options)"
                    :file-list="bannerFileList"
                    list-type="picture-card"
                    :on-remove="handleBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="MBanner">
                  <el-upload
                    :http-request="(options) => handlemBannerUpload(options)"
                    :file-list="mbannerFileList"
                    list-type="picture-card"
                    :on-remove="handlemBannerRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="缩略图">
                  <el-upload
                    :http-request="(options) => handleThumbUpload(options)"
                    :file-list="thumbnailFileList"
                    list-type="picture-card"
                    :on-remove="handleThumbRemove"
                    :limit="1"
                  >
                    <el-icon><Plus /></el-icon>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- Row 3: 新闻简介 -->
            <el-form-item label="新闻简介">
              <el-input type="textarea" v-model="fullform.description" placeholder="请输入新闻简介" :rows="3" />
            </el-form-item>

            <!-- Row 4: 富文本编辑器 -->
            <el-form-item label="新闻正文">
              <div style="border: 1px solid #dcdfe6; width: 100%">
                <Toolbar
                  :editor="editorRef"
                  :defaultConfig="toolbarConfig"
                  mode="default"
                  style="border-bottom: 1px solid #dcdfe6"
                />
                <Editor
                  v-model:html="editorContent"
                  :defaultConfig="editorConfig"
                  mode="default"
                  style="height: 400px; overflow-y: hidden"
                  @onCreated="handleCreated"
                />
              </div>
            </el-form-item>

      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="isEdit ? handleConfirmEditNew() : handleConfirmAddNew()">确认</el-button>
      </template>
    </el-dialog>
      </div>
       <div class="cont-con" v-show="activeTab == 'contact'">
       <!--  <div class="pro-top">
          <el-button type="primary" @click="handleAdd">添加</el-button>
          </div> -->
          
          <!-- 添加查询框区域 -->
          <div>
            <el-form 
              :model="contactSearchForm" 
              ref="contactQueryRef" 
              :inline="false" 
              label-width="100px"
            > 
              <el-row :gutter="10"> 
                <el-col :span="4"> 
                  <el-form-item label="咨询类型" prop="messageType" style="min-width: 260px"> 
                    <el-select 
                      v-model="contactSearchForm.messageType" 
                      placeholder="请选择咨询类型" 
                      clearable
                      style="width: 100%"
                    >
                      <el-option label="全部" :value="null" />
                      <el-option label="咨询" :value="1" />
                      <el-option label="售前合作" :value="2" />
                      <el-option label="媒体" :value="3" />
                    </el-select>
                  </el-form-item> 
                </el-col> 
                <el-col :span="8"  >
                  <el-form-item label="" prop="messageTime" style="min-width: 100%">
                    <el-date-picker
                      v-model="contactSearchForm.messageTime"
                      type="daterange"
                      unlink-panels
                      clearable
                      range-separator="-"
                      start-placeholder="操作日期起"
                      end-placeholder="操作日期终"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      @change="timeChange"
                      @input="handleDate"
                    />
                  </el-form-item>
                </el-col> 
                <el-col :span="12"> 
                  <el-form-item> 
                    <el-button type="primary" icon="Search" @click="handleContactSearch">搜索</el-button> 
                    <el-button icon="Refresh" @click="handleContactReset">重置</el-button> 
                  </el-form-item> 
                </el-col> 
              </el-row> 
            </el-form>
          </div>
          <div class="table-wrap">
            <el-table
            :data="cont_data.records"
            style="width: 100%;flex: 1; "
            
          >
            <el-table-column prop="name" label="姓名" align="left" class-name="text-column"/>
            <el-table-column prop="company" label="公司" align="center" class-name="text-column"/>
            <el-table-column prop="messageType" label="咨询类型" align="center" class-name="text-column">
              <template #default="scope">
                {{ formatMessageType(scope.row.messageType) }}
              </template> 
            </el-table-column>
            <el-table-column prop="content" label="反馈内容" align="center" class-name="text-column" show-overflow-tooltip="true">
            <!--  <template #default="scope">
                <img :src="scope.row.mbanner" style="width: 100px;" alt="图片预览" />
            </template> -->
            </el-table-column>
            <el-table-column prop="email" label="邮箱/电话" align="center" class-name="text-column" show-overflow-tooltip="true">
              <!-- <template #default="scope">
                <img
                  :src="scope.row.thumbnail"
                  style="width: 100px;"
                  alt="图片预览"
                  />
              </template> -->
            </el-table-column>
            <el-table-column prop="messageTime" label="时间" align="center" class-name="text-column">
            </el-table-column>
            <!-- <el-table-column prop="description" label="新闻描述" align="center" class-name="multiline-column"/> -->
            <!-- <el-table-column label="操作" align="right" class-name="action-column">
              <template #default="scope">
                <el-button size="small" type="primary" @click="detailshow(scope.row.id)">查看详情</el-button>
                <el-button size="small" type="danger" @click="detaildelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <pagination
            v-show="cont_data.total > 0"
            :total="cont_data.total"
            v-model:page="queryParams.current"
            v-model:limit="queryParams.size"
            @pagination="message"
          />
          </div>
      </div>
      <div class="home-order-con" v-show="activeTab == 'homeOrder'">
        <div class="table-wrap">
          <el-table :data="homeOrderList" style="width: 100%;" row-key="type">
            <el-table-column prop="sort" label="排序号" align="center" width="100" />
            <el-table-column prop="name" label="模块名称" align="center" />
            <el-table-column label="操作" align="center" width="200">
              <template #default="scope">
                <el-button
                  size="small"
                  :disabled="scope.$index === 0"
                  @click="handleHomeOrderMoveUp(scope.$index)"
                >上移</el-button>
                <el-button
                  size="small"
                  :disabled="scope.$index === homeOrderList.length - 1"
                  @click="handleHomeOrderMoveDown(scope.$index)"
                >下移</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="visitor-log-con" v-show="activeTab == 'visitorLog'">
        <div>
          <el-form
            :model="visitorLogSearchForm"
            ref="visitorLogQueryRef"
            :inline="false"
            label-width="100px"
          >
            <el-row>
              <el-col :span="4">
                <el-form-item label="设备类型" prop="deviceType" style="min-width: 200px">
                  <el-select
                    v-model="visitorLogSearchForm.deviceType"
                    placeholder="请选择设备类型"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="全部" :value="null" />
                    <el-option label="Desktop" value="Desktop" />
                    <el-option label="Mobile" value="Mobile" />
                    <el-option label="Tablet" value="Tablet" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="操作系统" prop="deviceOs" style="min-width: 200px">
                  <el-select
                    v-model="visitorLogSearchForm.deviceOs"
                    placeholder="请选择操作系统"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="全部" :value="null" />
                    <el-option label="Windows" value="Windows" />
                    <el-option label="MacOS" value="MacOS" />
                    <el-option label="iOS" value="iOS" />
                    <el-option label="Android" value="Android" />
                    <el-option label="Linux" value="Linux" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="浏览器" prop="deviceBrowser" style="min-width: 200px">
                  <el-select
                    v-model="visitorLogSearchForm.deviceBrowser"
                    placeholder="请选择浏览器"
                    clearable
                    style="width: 100%"
                  >
                    <el-option label="全部" :value="null" />
                    <el-option label="Chrome" value="Chrome" />
                    <el-option label="Safari" value="Safari" />
                    <el-option label="Firefox" value="Firefox" />
                    <el-option label="Edge" value="Edge" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="" prop="visitTime" style="min-width: 100%">
                  <el-date-picker
                    v-model="visitorLogSearchForm.visitTime"
                    type="daterange"
                    unlink-panels
                    clearable
                    range-separator="-"
                    start-placeholder="访问时间起"
                    end-placeholder="访问时间止"
                    format="YYYY-MM-DD"
                    value-format="YYYY-MM-DD"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12" :offset="20">
                <el-form-item>
                  <el-button type="primary" icon="Search" @click="handleVisitorLogSearch">搜索</el-button>
                  <el-button icon="Refresh" @click="handleVisitorLogReset">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="table-wrap">
          <el-table
            :data="tableData"
            style="width: 100%;flex: 1;"
          >
            <el-table-column prop="ip" label="访问IP" align="center" class-name="text-column"  show-overflow-tooltip />
            <el-table-column prop="deviceOs" label="操作系统" align="center" class-name="text-column"  />
            <el-table-column prop="deviceBrowser" label="浏览器" align="center" class-name="text-column" />
            <el-table-column prop="deviceType" label="设备类型" align="center" class-name="text-column"  />
            <el-table-column prop="createTime" label="访问时间" align="center" class-name="text-column"  />
            <el-table-column prop="language" label="浏览器语言" align="center" class-name="text-column"  />
            <el-table-column prop="duration" label="访问时长(s)" align="center" class-name="text-column"  />
          </el-table>
          <pagination
            v-show="total > 0"
            :total="total"
            v-model:page="queryParams.current"
            v-model:limit="queryParams.size"
            @pagination="Detailgender"
          />
        </div>
      </div>
      <!--  <div class="about-con" v-show="activeTab.type === 'about'">
        about
      </div> -->
    </div>

  </div>

</template>

<script setup name="WomuBackend">
import { defineEmits } from 'vue';
import { onMounted, onUnmounted } from 'vue';
import { ref, computed, nextTick } from 'vue';
import { ElButton } from 'element-plus';
import { ElMessage } from 'element-plus';
import { uploadImage } from '@/api/upload';
import { addText } from '@/api/Posttext';
import { addNews, updateNews, deleteNews, getNewsDetail, getNewsPage, setNewsTop } from '@/api/news';
import { addCase, updateCase, deleteCase, getCaseDetail, getCasePage } from '@/api/case';
import { addDeviceType, updateDeviceType, deleteDeviceType, getDeviceTypeDetail, getDeviceTypePage, getDeviceTypeList } from '@/api/deviceType';
import { addDevice, updateDevice, deleteDevice, getDeviceDetail, getDevicePage } from '@/api/device';
import { addSolution, updateSolution, deleteSolution, getSolutionDetail, getSolutionPage } from '@/api/solution';
import { addProduct, updateProduct, deleteProduct, getProductDetail, getProductPage } from '@/api/product';
import { getDetailpage } from '@/api/getdetailpage';
import { getMessages } from '@/api/getMessage';
import { useRouter,useRoute} from 'vue-router';
import { deleteItem } from '@/api/Deletedata'
import { getHomeSectionOrder, saveHomeSectionOrder, updateHomeSectionOrder } from '@/api/homeSection'
import { getVisitorLogPage } from '@/api/visitorLog'

import '@wangeditor/editor/dist/css/style.css'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
const router = useRouter();
const tableWidth = ref(700)
const tableHeight = ref(300)
const dialogVisible = ref(false)
const cont_data = ref([])

const route=useRoute()
const objectType = route.query.objectType || 'product'
let lang = ref('1')
const queryParams = ref({
  appId: 1,
  objectType: objectType,
  current: 1,
  size: 10,
  searchText: ''
})
const total = ref(0)

const contactSearchForm = ref({
  messageType: null,
  messageTime: null
})

const visitorLogSearchForm = ref({
  deviceType: null,
  deviceOs: null,
  deviceBrowser: null,
  visitTime: null
})

const panes = computed(() => {
  const isZh = lang.value === '1'
  return [
    { label: isZh ? '产品平台' : 'Product Platform', type: 'product' },
    { label: isZh ? '解决方案' : 'Our Solutions', type: 'solution' },
    { label: isZh ? '行业案例' : 'Industry Case', type: 'case' },
    { label: isZh ? '硬件设备' : 'Hard Device', type: 'device' },
    { label: isZh ? '硬件设备类型' : 'Device Type', type: 'deviceType' },
    { label: isZh ? '新闻' : 'News', type: 'new' },
    { label: isZh ? '联系我们' : 'Contact Us', type: 'contact' },
    { label: isZh ? '首页排序' : 'Home Order', type: 'homeOrder' },
    { label: isZh ? '访问来源' : 'Visitor Log', type: 'visitorLog' },
  ]
})
const activeTab = ref('product');

const homeOrderList = ref([])
const defaultHomeSections = [
  { type: 'solution', name: '解决方案' },
  { type: 'product', name: '软件产品' },
  { type: 'productHard', name: '硬件产品' },
  { type: 'case', name: '成功案例' },
  { type: 'new', name: '新闻' },
]

const nameToTypeMap = {
  '我们的解决方案': 'solution',
  'Our Solutions': 'solution',
  '软件产品': 'product',
  'Software Products': 'product',
  '硬件产品': 'productHard',
  'Hardware Products': 'productHard',
  '成功案例': 'case',
  'Success Cases': 'case',
  '新闻': 'new',
  'News': 'new'
}

async function fetchHomeOrder() {
  try {
    const res = await getHomeSectionOrder({ appId: queryParams.value.appId })
    if (res.code === 200 && res.data && res.data.length) {
      homeOrderList.value = res.data.map((item, index) => ({
        ...item,
        type: nameToTypeMap[item.name] || '',
        sort: index + 1
      }))
    } else {
      homeOrderList.value = defaultHomeSections.map((item, index) => ({
        ...item,
        sort: index + 1
      }))
    }
  } catch {
    homeOrderList.value = defaultHomeSections.map((item, index) => ({
      ...item,
      sort: index + 1
    }))
  }
}

async function handleHomeOrderMoveUp(index) {
  if (index === 0) return
  const list = homeOrderList.value
  const itemA = list[index - 1]
  const itemB = list[index]
  ;[list[index - 1], list[index]] = [itemB, itemA]
  list.forEach((item, i) => { item.sort = i + 1 })
  try {
    await Promise.all([
      updateHomeSectionOrder({ id: itemA.id, type: itemA.type, sort: itemA.sort, name: itemA.name }),
      updateHomeSectionOrder({ id: itemB.id, type: itemB.type, sort: itemB.sort, name: itemB.name })
    ])
    ElMessage.success('排序保存成功')
  } catch (error) {
    console.error('保存排序失败：', error)
    ElMessage.error('保存排序失败')
    ;[list[index - 1], list[index]] = [itemA, itemB]
    list.forEach((item, i) => { item.sort = i + 1 })
  }
}

async function handleHomeOrderMoveDown(index) {
  if (index === homeOrderList.value.length - 1) return
  const list = homeOrderList.value
  const itemA = list[index]
  const itemB = list[index + 1]
  ;[list[index], list[index + 1]] = [itemB, itemA]
  list.forEach((item, i) => { item.sort = i + 1 })
  try {
    await Promise.all([
      updateHomeSectionOrder({ id: itemA.id, type: itemA.type, sort: itemA.sort, name: itemA.name }),
      updateHomeSectionOrder({ id: itemB.id, type: itemB.type, sort: itemB.sort, name: itemB.name })
    ])
    ElMessage.success('排序保存成功')
  } catch (error) {
    console.error('保存排序失败：', error)
    ElMessage.error('保存排序失败')
    ;[list[index], list[index + 1]] = [itemA, itemB]
    list.forEach((item, i) => { item.sort = i + 1 })
  }
}

async function handleHomeOrderSave() {
  try {
    const payload = {
      appId: queryParams.value.appId,
      sections: homeOrderList.value.map((item, index) => ({
        type: item.type,
        sort: index + 1,
        name: item.name
      }))
    }
    const res = await saveHomeSectionOrder(payload)
    if (res.code === 200) {
      ElMessage.success('排序保存成功')
    }
  } catch (error) {
    console.error('保存排序失败：', error)
    ElMessage.error('保存排序失败')
  }
}

function updateTableSize() {
  tableWidth.value = Math.floor(window.innerWidth * 0.9) // 主体区域 88% * 内边距 90%
  tableHeight.value = Math.floor(window.innerHeight * 0.9)
}
onMounted(() => {
  Startrender(false)
  window.scrollTo(0, 0);
  updateTableSize()
  window.addEventListener('resize', updateTableSize)
  // if (!activeTab.value) {
  //   activeTab.value = panes.value[0].type;
  // }
  Detailgender()
})
onUnmounted(() => {
  Startrender(true)
  window.removeEventListener('resize', updateTableSize)
  const editor = editorRef.value
  if (editor) {
    editor.destroy()
    editorRef.value = null
  }
  const caseEditor = caseEditorRef.value
  if (caseEditor) {
    caseEditor.destroy()
    caseEditorRef.value = null
  }
  const deviceEditor = deviceEditorRef.value
  if (deviceEditor) {
    deviceEditor.destroy()
    deviceEditorRef.value = null
  }
  const solutionEditor = solutionEditorRef.value
  if (solutionEditor) {
    solutionEditor.destroy()
    solutionEditorRef.value = null
  }
  const productEditor = productEditorRef.value
  if (productEditor) {
    productEditor.destroy()
    productEditorRef.value = null
  }
  const deviceTypeEditor = deviceTypeEditorRef.value
  if (deviceTypeEditor) {
    deviceTypeEditor.destroy()
    deviceTypeEditorRef.value = null
  }
})
async function Detailgender() {
  console.log('当前页:',activeTab.value);
  let tableDatas = {};
  if (activeTab.value === 'new') {
    tableDatas = await getNewsPage(queryParams.value);
  } else if (activeTab.value === 'product') {
    tableDatas = await getProductPage(queryParams.value);
  } else if (activeTab.value === 'solution') {
    tableDatas = await getSolutionPage(queryParams.value);
  } else if (activeTab.value === 'case') {
    tableDatas = await getCasePage(queryParams.value);
  } else if (activeTab.value === 'deviceType') {
    tableDatas = await getDeviceTypePage(queryParams.value);
  } else if (activeTab.value === 'device') {
    tableDatas = await getDevicePage(queryParams.value);
    await fetchDeviceTypeList();
  } else if (activeTab.value === 'visitorLog') {
    const searchParams = {
      appId: queryParams.value.appId,
      current: queryParams.value.current,
      size: queryParams.value.size
    }
    if (visitorLogSearchForm.value.deviceType) {
      searchParams.deviceType = visitorLogSearchForm.value.deviceType
    }
    if (visitorLogSearchForm.value.deviceOs) {
      searchParams.deviceOs = visitorLogSearchForm.value.deviceOs
    }
    if (visitorLogSearchForm.value.deviceBrowser) {
      searchParams.deviceBrowser = visitorLogSearchForm.value.deviceBrowser
    }
    if (visitorLogSearchForm.value.visitTime && visitorLogSearchForm.value.visitTime.length === 2) {
      searchParams.visitTimeStart = visitorLogSearchForm.value.visitTime[0] + ' 00:00:00'
      searchParams.visitTimeEnd = visitorLogSearchForm.value.visitTime[1] + ' 23:59:59'
    }
    tableDatas = await getVisitorLogPage(searchParams);
  } else {
    tableDatas = await getDetailpage(queryParams.value);
  }
  tableData.value = [];
  console.log('返回数据:', tableDatas);
  total.value = tableDatas.data.total;
  console.log('返回数据:', total.value);
  tableDatas.data.records.map(item => {
    tableData.value.push(item);
    console.log(tableData.value);
  })
}


async function message() {
  const searchParams = {
    appId: 2,
    objectType: 'contact',
    current: queryParams.value.current, 
    size: queryParams.value.size
  }
  
  // 咨询类型筛选
  if (contactSearchForm.value.messageType !== null && contactSearchForm.value.messageType !== '') {
    searchParams.messageType = contactSearchForm.value.messageType
  }
  
  // 时间范围筛选 - 使用 messageTimeStart 和 messageTimeEnd
  if (contactSearchForm.value.messageTime && contactSearchForm.value.messageTime.length === 2) {
    const startDate = new Date(contactSearchForm.value.messageTime[0])
    const endDate = new Date(contactSearchForm.value.messageTime[1])
    
    // 格式化为 YYYY-MM-DD HH:mm:ss 格式
    const formatDateTime = (date) => {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
    
    // 设置开始时间为当天 00:00:00
    startDate.setHours(0, 0, 0, 0)
    // 设置结束时间为当天 23:59:59
    endDate.setHours(23, 59, 59, 999)
    
    searchParams.messageTimeStart = formatDateTime(startDate)
    searchParams.messageTimeEnd = formatDateTime(endDate)
  }
  
  console.log('查询参数:', searchParams)
  
  try {
    const cont_res = await getMessages(searchParams)
    console.log('原始查询结果:', cont_res.data)
    
    // 直接使用后端返回的数据，不要修改 total
    cont_data.value = cont_res.data
    
    console.log('最终结果:', cont_data.value)
    
  } catch (error) {
    console.error('查询失败:', error)
  }
}

 const formatMessageType = (type) => {
  const typeMap = {
    1: '咨询',
    2: '售前合作',
    3: '媒体'
  };
  return typeMap[type] || 'Unknown';
};

// 添加查询处理函数
const handleContactSearch = () => {
  queryParams.value.current = 1 // 重置到第一页
  message()
}

// 添加时间处理函数
const timeChange = (value) => {
  console.log('时间范围变化:', value)
  contactSearchForm.value.messageTime = value
}

const handleDate = (value) => {
  console.log('时间输入变化:', value)
}

// 添加重置处理函数
const handleContactReset = () => {
  contactSearchForm.value = {
    messageType: null,
    messageTime: null
  }
  queryParams.value.current = 1 // 重置到第一页
  message()
}

const handleVisitorLogSearch = () => {
  queryParams.value.current = 1
  Detailgender()
}

const handleVisitorLogReset = () => {
  visitorLogSearchForm.value = {
    deviceType: null,
    deviceOs: null,
    deviceBrowser: null,
    visitTime: null
  }
  queryParams.value.current = 1
  Detailgender()
}
// banner
const bannerFileList = ref([]);
const mbannerFileList = ref([]);
const thumbnailFileList = ref([]);

const handleBannerUpload = async (options) => {
  const { file, onSuccess, onError } = options;
  const formData = new FormData();
  formData.append('file', file);
  try {
    const res = await uploadImage(formData);
    if (res.code === 200) {
      file.url = res.data;
      bannerFileList.value = [file];
      fullform.value.banner = res.data;
      onSuccess(res, file);
    } else {
      onError(res.message || '上传失败');
    }
  } catch (err) {
    onError(err);
  }
};
const handlemBannerUpload = async (options) => {
  const { file, onSuccess, onError } = options;
  const formData = new FormData();
  formData.append('file', file);
  try {
    const res = await uploadImage(formData);
    if (res.code === 200) {
      file.url = res.data;
      mbannerFileList.value = [file];
      fullform.value.mbanner = res.data;
      onSuccess(res, file);
    } else {
      onError(res.message || '上传失败');
    }
  } catch (err) {
    onError(err);
  }
};

const handleThumbUpload = async (options) => {
  const { file, onSuccess, onError } = options;
  const formData = new FormData();
  formData.append('file', file);
  try {
    const res = await uploadImage(formData);
    if (res.code === 200) {
      file.url = res.data;
      thumbnailFileList.value = [file];
      fullform.value.thumbnail = res.data;
      onSuccess(res, file);
    } else {
      onError(res.message || '上传失败');
    }
  } catch (err) {
    onError(err);
  }
};

const handleBannerRemove = () => {
  bannerFileList.value = [];
  fullform.value.banner = '';
};
const handlemBannerRemove = () => {
  mbannerFileList.value = [];
  fullform.value.mbanner = '';
};

const handleThumbRemove = () => {
  thumbnailFileList.value = [];
  fullform.value.thumbnail = '';
};

//点击详情显示详情
function detailshow(id) {
  router.push(`detail?id=${id}`);
}
// 点击true为中文appid为1，点击false为英文appid为1.1

// 传参
// function editid(id,type) {

// }

function handleTabChange(params) {
  console.log(params);
  console.log(activeTab.value);
  panes.value.forEach(element => {
    console.log(element);
    if (element.type == params) {
      queryParams.value.objectType = element.type
      console.log(queryParams.value);
    }
  });

 
  
  // activeTab.value = params
  // console.log(activeTab.value);
  
  // console.log(params.id);
  // console.log(objectType.value);
  tableData.value = []
  if (params === 'contact') {
    message()
  } else if (params === 'homeOrder') {
    fetchHomeOrder()
  } else if (params === 'visitorLog') {
    Detailgender()
  } else {
    Detailgender()
  }
}
const handleLangChange = (value) => {
  queryParams.value.appId = Number(value)
  queryParams.value.current = 1
  if (activeTab.value === 'contact') {
    message()
  } else if (activeTab.value === 'homeOrder') {
    fetchHomeOrder()
  } else if (activeTab.value === 'visitorLog') {
    Detailgender()
  } else {
    Detailgender()
  }
}
const emit = defineEmits(['showlink'])
function Startrender(type) {
  console.log(type);
  emit('showlink', type)
}
// 数据
const tableData = ref([])
const editorRef = ref(null)
const editorContent = ref('')
const isEdit = ref(false)
const editingId = ref(null)
// 案例相关状态
const caseEditorRef = ref(null)
const caseEditorContent = ref('')
const caseIsEdit = ref(false)
const caseEditingId = ref(null)
// 硬件设备类型相关状态
const deviceTypeDialogVisible = ref(false)
const deviceTypeIsEdit = ref(false)
const deviceTypeEditingId = ref(null)
const deviceTypeForm = ref({
  name: '',
  sort: 0,
  banner: '',
  mbanner: '',
  thumbnail: '',
  description: '',
  context: ''
})
const deviceTypeBannerFileList = ref([])
const deviceTypeMBannerFileList = ref([])
const deviceTypeThumbnailFileList = ref([])
const deviceTypeEditorRef = ref(null)
const deviceTypeEditorContent = ref('')
// 硬件设备相关状态
const deviceEditorRef = ref(null)
const deviceEditorContent = ref('')
const deviceIsEdit = ref(false)
const deviceEditingId = ref(null)
const deviceTypeList = ref([])
const deviceList = ref([])
const deviceBanner2FileList = ref([])
const deviceBanner3FileList = ref([])
// 解决方案相关状态
const solutionEditorRef = ref(null)
const solutionEditorContent = ref('')
const solutionIsEdit = ref(false)
const solutionEditingId = ref(null)
// 产品相关状态
const productEditorRef = ref(null)
const productEditorContent = ref('')
const productIsEdit = ref(false)
const productEditingId = ref(null)
const toolbarConfig = ref({
  excludeKeys: []
})
const editorConfig = ref({
  placeholder: '请输入新闻正文内容...',
  MENU_CONF: {
    uploadImage: {
      async customUpload(file, insertFn) {
        const formData = new FormData()
        formData.append('file', file)
        try {
          const res = await uploadImage(formData)
          if (res.code === 200) {
            insertFn(res.data)
          } else {
            ElMessage.error('图片上传失败')
          }
        } catch (err) {
          ElMessage.error('图片上传失败')
        }
      }
    }
  }
})

const handleCreated = (editor) => {
  editorRef.value = editor
  console.log('富文本编辑器创建成功！')
}

const caseEditorConfig = ref({
  placeholder: '请输入案例正文内容...',
  MENU_CONF: {
    uploadImage: {
      async customUpload(file, insertFn) {
        const formData = new FormData()
        formData.append('file', file)
        try {
          const res = await uploadImage(formData)
          if (res.code === 200) {
            insertFn(res.data)
          } else {
            ElMessage.error('图片上传失败')
          }
        } catch (err) {
          ElMessage.error('图片上传失败')
        }
      }
    }
  }
})

const handleCaseEditorCreated = (editor) => {
  caseEditorRef.value = editor
}

const deviceEditorConfig = ref({
  placeholder: '请输入设备正文内容...',
  MENU_CONF: {
    uploadImage: {
      async customUpload(file, insertFn) {
        const formData = new FormData()
        formData.append('file', file)
        try {
          const res = await uploadImage(formData)
          if (res.code === 200) {
            insertFn(res.data)
          } else {
            ElMessage.error('图片上传失败')
          }
        } catch (err) {
          ElMessage.error('图片上传失败')
        }
      }
    }
  }
})

const handleDeviceEditorCreated = (editor) => {
  deviceEditorRef.value = editor
}

const solutionEditorConfig = ref({
  placeholder: '请输入解决方案正文内容...',
  MENU_CONF: {
    uploadImage: {
      async customUpload(file, insertFn) {
        const formData = new FormData()
        formData.append('file', file)
        try {
          const res = await uploadImage(formData)
          if (res.code === 200) {
            insertFn(res.data)
          } else {
            ElMessage.error('图片上传失败')
          }
        } catch (err) {
          ElMessage.error('图片上传失败')
        }
      }
    }
  }
})

const handleSolutionEditorCreated = (editor) => {
  solutionEditorRef.value = editor
}

const productEditorConfig = ref({
  placeholder: '请输入产品正文内容...',
  MENU_CONF: {
    uploadImage: {
      async customUpload(file, insertFn) {
        const formData = new FormData()
        formData.append('file', file)
        try {
          const res = await uploadImage(formData)
          if (res.code === 200) {
            insertFn(res.data)
          } else {
            ElMessage.error('图片上传失败')
          }
        } catch (err) {
          ElMessage.error('图片上传失败')
        }
      }
    }
  }
})

const handleProductEditorCreated = (editor) => {
  productEditorRef.value = editor
}

const deviceTypeEditorConfig = ref({
  placeholder: '请输入类型正文内容...',
  MENU_CONF: {
    uploadImage: {
      async customUpload(file, insertFn) {
        const formData = new FormData()
        formData.append('file', file)
        try {
          const res = await uploadImage(formData)
          if (res.code === 200) {
            insertFn(res.data)
          } else {
            ElMessage.error('图片上传失败')
          }
        } catch (err) {
          ElMessage.error('图片上传失败')
        }
      }
    }
  }
})

const handleDeviceTypeEditorCreated = (editor) => {
  deviceTypeEditorRef.value = editor
}

const fullform = ref({
name: '',
  shortname: '',
  productIds: [],
  solutionIds: [],
  caseIds: [],
  deviceTypeId: null,
  deviceIds: [],
  newsTime: '',
  sort: 0,
  banner: '',
  banner2: '',
  banner3: '',
  mbanner:'',
  thumbnail: '',
  description: '',
  content: '',
  form: [{ type: '', value: '', fileList: [] }]
})

const caseList = ref([])

//添加功能
async function handleAdd() {
  if (activeTab.value === 'new') {
    isEdit.value = false
    editingId.value = null
    resetNewsForm()
  }
  dialogVisible.value = !dialogVisible.value;
  if (activeTab.value === 'new' && dialogVisible.value) {
    await nextTick()
    if (editorRef.value) {
      editorRef.value.setHtml('')
    }
  }
}

const handleConfirmAdd = async () => {
  // 校验主表单字段
  const { name, shortname, banner,mbanner, thumbnail, description,form} = fullform.value;
  if (!name || !shortname || !banner || !mbanner || !thumbnail || !description) {
    if (activeTab.value === 'product') {
      ElMessage.warning('请填写完整产品信息');
      return;
    }
    else if (activeTab.value === 'solution') {
      ElMessage.warning('请填写完整解决方案信息');
      return;
    }
    else if (activeTab.value === 'case') {
      ElMessage.warning('请填写完整案例信息');
      return;
    }
    else if (activeTab.value === 'device') {
      ElMessage.warning('请填写完整设备信息');
      return;
    }
    else if (activeTab.value === 'new') {
      ElMessage.warning('请填写完整新闻信息');
      return;
    }
  }

  for (const item of form) {
    // 对于核心功能类型，检查 features 数组
    if (item.type === '核心功能') {
      if (!item.type || !item.features || item.features.length === 0) {
        if (activeTab.value === 'product') {
          ElMessage.warning('请填写完整产品内容项');
          return;
        }
        else if (activeTab.value ==='solution') {
          ElMessage.warning('请填写完整解决方案内容项');
          return;
        }
        else if (activeTab.value === 'case') {
          ElMessage.warning('请填写完整案例内容项');
          return;
        }
        else if (activeTab.value === 'device') {
          ElMessage.warning('请填写完整设备内容项');
          return;
        }
        else if (activeTab.value === 'new') {
          ElMessage.warning('请填写完整新闻内容项');
          return;
        }
      }
      // 检查每个功能项是否完整
      for (const feature of item.features) {
        if (!feature.title || !feature.valueList) {
          if (activeTab.value === 'product') {
            ElMessage.warning('请填写完整核心功能项');
            return;
          }
          else if (activeTab.value ==='solution') {
            ElMessage.warning('请填写完整核心功能项');
            return;
          }
          else if (activeTab.value === 'case') {
            ElMessage.warning('请填写完整核心功能项');
            return;
          }
          else if (activeTab.value === 'device') {
            ElMessage.warning('请填写完整核心功能项');
            return;
          }

          else if (activeTab.value === 'new') {
            ElMessage.warning('请填写完整核心功能项');
            return;
          }
        }
      }
    } else {
      // 其他类型的原有验证逻辑
      if (!item.type || !item.value) {
        if (activeTab.value === 'product') {
          ElMessage.warning('请填写完整产品内容项');
          return;
        }
        else if (activeTab.value ==='solution') {
          ElMessage.warning('请填写完整解决方案内容项');
          return;
        }
        else if (activeTab.value === 'case') {
          ElMessage.warning('请填写完整案例内容项');
          return;
        }
        else if (activeTab.value === 'device') {
          ElMessage.warning('请填写完整设备内容项');
          return;
        }

        else if (activeTab.value === 'new') {
          ElMessage.warning('请填写完整新闻内容项');
          return;
        }
      }
    }
  }

  // 映射 itemType
  const typeMap = {
    '标题': 1,
    '正文': 2,
    '视频': 3,
    '单图片': 4,
    '多图片': 5,
    '副标题': 6,
    '带点列表': 7,
    '核心功能': 8,
  };

  // 构造最终数据结构
  const payload = {
    appId: queryParams.value.appId,
    objectType: queryParams.value.objectType,
    productIds: fullform.value.productIds,
    solutionIds: fullform.value.solutionIds,
    name,
    shortName: shortname,
    banner,
    mbanner,
    thumbnail,
    description,
    newsTime: fullform.value.newsTime,
    content: fullform.value.content,
    items: form.map(item => {
      const itemType = typeMap[item.type];

      if (item.type === '核心功能') {
        const normalized = (Array.isArray(item.features) ? item.features : [])
          .map(f => ({
            title: f.title || '',
            valueList: Array.isArray(f.valueList)
              ? f.valueList.join(';') // 将数组转换为分号分隔的字符串
              : (f.valueList ? f.valueList.split(/[;\n]/).map(s => s.trim()).filter(Boolean).join(';') : '')
          }))
          .filter(f => f.title || f.valueList);

        return {
          itemType,
          itemContent: JSON.stringify(normalized) // 转换为 JSON 字符串
        };
      }

      return {
        itemType,
        itemContent: item.value
      };
    })
  };

  console.log('提交数据：', payload);
  try {
    const res = activeTab.value === 'new'
      ? await addNews(payload)
      : await addText(payload);
    if (res.code === 200) {
      ElMessage.success('添加成功');
    }
  }catch (error) {
    console.error('添加失败：', error);
    ElMessage.error('添加失败');
  }
  ElMessage.success('提交成功');
  dialogVisible.value = false;
  fullform.value = {
    name: '',
    shortname: '',
    productIds: [],
    solutionIds: [],
    banner: '',
    mbanner:'',
    thumbnail: '',
    newsTime:'',
    description: '',
    content: '',
    form: [{ type: '', value: '', fileList: [] }]
  };
  bannerFileList.value = [];
mbannerFileList.value = [];
thumbnailFileList.value = [];
  tableData.value = [];
  Detailgender()
};

async function handleConfirmAddNew() {
  const { name, newsTime, banner, mbanner, thumbnail, description } = fullform.value

  // 直接从编辑器实例获取 HTML，避免 v-model 同步时机问题
  const content = editorRef.value ? editorRef.value.getHtml() : ''

  if (!name || !newsTime || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整新闻信息')
    return
  }

  const payload = {
    appId: queryParams.value.appId,
    name,
    newsTime,
    banner,
    mbanner,
    thumbnail,
    description,
    context: content
  }
  console.log('提交数据：', payload)
  try {
    const res = await addNews(payload)
    if (res.code === 200) {
      ElMessage.success('添加成功')
      dialogVisible.value = false
      resetNewsForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('添加失败：', error)
    ElMessage.error('添加失败')
  }
}

async function handleConfirmEditNew() {
  const { name, newsTime, banner, mbanner, thumbnail, description } = fullform.value

  const content = editorRef.value ? editorRef.value.getHtml() : ''

  if (!name || !newsTime || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整新闻信息')
    return
  }

  const payload = {
    id: editingId.value,
    appId: queryParams.value.appId,
    name,
    newsTime,
    banner,
    mbanner,
    thumbnail,
    description,
    context: content
  }
  console.log('更新数据：', payload)
  try {
    const res = await updateNews(payload)
    if (res.code === 200) {
      ElMessage.success('修改成功')
      dialogVisible.value = false
      isEdit.value = false
      editingId.value = null
      resetNewsForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('修改失败：', error)
    ElMessage.error('修改失败')
  }
}

async function handleEditNews(id) {
  try {
    const res = await getNewsDetail(id)
    if (res.code === 200) {
      const detail = res.data
      editingId.value = detail.id
      isEdit.value = true

      fullform.value.name = detail.name || ''
      fullform.value.newsTime = detail.newsTime || ''
      fullform.value.banner = detail.banner || ''
      fullform.value.mbanner = detail.mbanner || ''
      fullform.value.thumbnail = detail.thumbnail || ''
      fullform.value.description = detail.description || ''

      // 回显图片文件列表
      bannerFileList.value = detail.banner ? [{ name: 'banner', url: detail.banner }] : []
      mbannerFileList.value = detail.mbanner ? [{ name: 'mbanner', url: detail.mbanner }] : []
      thumbnailFileList.value = detail.thumbnail ? [{ name: 'thumbnail', url: detail.thumbnail }] : []

      // 先打开弹窗，等编辑器就绪后再设置 HTML 内容
      dialogVisible.value = true
      await nextTick()
      if (editorRef.value) {
        editorRef.value.setHtml(detail.context || '')
      }
    }
  } catch (error) {
    console.error('获取新闻详情失败：', error)
    ElMessage.error('获取新闻详情失败')
  }
}

// 案例相关函数
async function handleCaseAdd() {
  caseIsEdit.value = false
  caseEditingId.value = null
  resetCaseForm()
  dialogVisible.value = true
  await nextTick()
  if (caseEditorRef.value) {
    caseEditorRef.value.setHtml('')
  }
}

async function handleCaseConfirmAdd() {
  const { name, sort, banner, mbanner, thumbnail, description } = fullform.value
  const content = caseEditorRef.value ? caseEditorRef.value.getHtml() : ''

  if (!name || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整案例信息')
    return
  }

  const payload = {
    appId: queryParams.value.appId,
    name,
    sort: sort ?? 0,
    banner,
    mbanner,
    thumbnail,
    description,
    context: content
  }
  console.log('提交数据：', payload)
  try {
    const res = await addCase(payload)
    if (res.code === 200) {
      ElMessage.success('添加成功')
      dialogVisible.value = false
      resetCaseForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('添加失败：', error)
    ElMessage.error('添加失败')
  }
}

async function handleCaseConfirmEdit() {
  const { name, sort, banner, mbanner, thumbnail, description } = fullform.value
  const content = caseEditorRef.value ? caseEditorRef.value.getHtml() : ''

  if (!name || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整案例信息')
    return
  }

  const payload = {
    id: caseEditingId.value,
    appId: queryParams.value.appId,
    name,
    sort: sort ?? 0,
    banner,
    mbanner,
    thumbnail,
    description,
    context: content
  }
  console.log('更新数据：', payload)
  try {
    const res = await updateCase(payload)
    if (res.code === 200) {
      ElMessage.success('修改成功')
      dialogVisible.value = false
      caseIsEdit.value = false
      caseEditingId.value = null
      resetCaseForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('修改失败：', error)
    ElMessage.error('修改失败')
  }
}

async function handleCaseEdit(id) {
  try {
    const res = await getCaseDetail(id)
    if (res.code === 200) {
      const detail = res.data
      caseEditingId.value = detail.id
      caseIsEdit.value = true

      fullform.value.name = detail.name || ''
      fullform.value.sort = detail.sort ?? 0
      fullform.value.banner = detail.banner || ''
      fullform.value.mbanner = detail.mbanner || ''
      fullform.value.thumbnail = detail.thumbnail || ''
      fullform.value.description = detail.description || ''

      bannerFileList.value = detail.banner ? [{ name: 'banner', url: detail.banner }] : []
      mbannerFileList.value = detail.mbanner ? [{ name: 'mbanner', url: detail.mbanner }] : []
      thumbnailFileList.value = detail.thumbnail ? [{ name: 'thumbnail', url: detail.thumbnail }] : []

      dialogVisible.value = true
      await nextTick()
      if (caseEditorRef.value) {
        caseEditorRef.value.setHtml(detail.context || '')
      }
    }
  } catch (error) {
    console.error('获取案例详情失败：', error)
    ElMessage.error('获取案例详情失败')
  }
}

async function handleCaseDelete(id) {
  try {
    const res = await deleteCase(id)
    if (res.code === 200) {
      ElMessage.success('删除成功')
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('删除失败：', error)
    ElMessage.error('删除失败')
  }
}

function handleCaseDialogClose() {
  caseIsEdit.value = false
  caseEditingId.value = null
  resetCaseForm()
}

// 产品相关函数
async function handleProductAdd() {
  productIsEdit.value = false
  productEditingId.value = null
  resetProductForm()
  await fetchCaseList()
  dialogVisible.value = true
  await nextTick()
  if (productEditorRef.value) {
    productEditorRef.value.setHtml('')
  }
}

async function handleProductConfirmAdd() {
  const { name, sort, banner, mbanner, thumbnail, description, caseIds } = fullform.value
  const content = productEditorRef.value ? productEditorRef.value.getHtml() : ''

  if (!name || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整产品信息')
    return
  }

  const payload = {
    appId: queryParams.value.appId,
    name,
    sort: sort ?? 0,
    banner,
    mbanner,
    thumbnail,
    description,
    caseIds: caseIds || [],
    context: content
  }
  try {
    const res = await addProduct(payload)
    if (res.code === 200) {
      ElMessage.success('添加成功')
      dialogVisible.value = false
      resetProductForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('添加失败：', error)
    ElMessage.error('添加失败')
  }
}

async function handleProductConfirmEdit() {
  const { name, sort, banner, mbanner, thumbnail, description, caseIds } = fullform.value
  const content = productEditorRef.value ? productEditorRef.value.getHtml() : ''

  if (!name || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整产品信息')
    return
  }

  const payload = {
    id: productEditingId.value,
    appId: queryParams.value.appId,
    name,
    sort: sort ?? 0,
    banner,
    mbanner,
    thumbnail,
    description,
    caseIds: caseIds || [],
    context: content
  }
  try {
    const res = await updateProduct(payload)
    if (res.code === 200) {
      ElMessage.success('修改成功')
      dialogVisible.value = false
      productIsEdit.value = false
      productEditingId.value = null
      resetProductForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('修改失败：', error)
    ElMessage.error('修改失败')
  }
}

async function handleProductEdit(id) {
  try {
    const res = await getProductDetail(id)
    if (res.code === 200) {
      const detail = res.data
      productEditingId.value = detail.id
      productIsEdit.value = true

      fullform.value.name = detail.name || ''
      fullform.value.sort = detail.sort ?? 0
      fullform.value.banner = detail.banner || ''
      fullform.value.mbanner = detail.mbanner || ''
      fullform.value.thumbnail = detail.thumbnail || ''
      fullform.value.description = detail.description || ''
      fullform.value.caseIds = detail.caseIds || []

      bannerFileList.value = detail.banner ? [{ name: 'banner', url: detail.banner }] : []
      mbannerFileList.value = detail.mbanner ? [{ name: 'mbanner', url: detail.mbanner }] : []
      thumbnailFileList.value = detail.thumbnail ? [{ name: 'thumbnail', url: detail.thumbnail }] : []

      await fetchCaseList()
      dialogVisible.value = true
      await nextTick()
      if (productEditorRef.value) {
        productEditorRef.value.setHtml(detail.context || '')
      }
    }
  } catch (error) {
    console.error('获取产品详情失败：', error)
    ElMessage.error('获取产品详情失败')
  }
}

async function handleProductDelete(id) {
  try {
    const res = await deleteProduct(id)
    if (res.code === 200) {
      ElMessage.success('删除成功')
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('删除失败：', error)
    ElMessage.error('删除失败')
  }
}

function handleProductDialogClose() {
  productIsEdit.value = false
  productEditingId.value = null
  resetProductForm()
}

function resetProductForm() {
  fullform.value.name = ''
  fullform.value.sort = 0
  fullform.value.banner = ''
  fullform.value.mbanner = ''
  fullform.value.thumbnail = ''
  fullform.value.description = ''
  fullform.value.caseIds = []
  productEditorContent.value = ''
  bannerFileList.value = []
  mbannerFileList.value = []
  thumbnailFileList.value = []
}

async function fetchCaseList() {
  try {
    const res = await getCasePage({ appId: queryParams.value.appId, current: 1, size: 1000 })
    caseList.value = res.data?.records || []
  } catch (error) {
    console.error('获取案例列表失败：', error)
  }
}

// 解决方案相关函数
async function handleSolutionAdd() {
  solutionIsEdit.value = false
  solutionEditingId.value = null
  resetSolutionForm()
  dialogVisible.value = true
  await nextTick()
  if (solutionEditorRef.value) {
    solutionEditorRef.value.setHtml('')
  }
}

async function handleSolutionConfirmAdd() {
  const { name, sort, banner, mbanner, thumbnail, description } = fullform.value
  const content = solutionEditorRef.value ? solutionEditorRef.value.getHtml() : ''

  if (!name || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整解决方案信息')
    return
  }

  const payload = {
    appId: queryParams.value.appId,
    name,
    sort: sort ?? 0,
    banner,
    mbanner,
    thumbnail,
    description,
    context: content
  }
  try {
    const res = await addSolution(payload)
    if (res.code === 200) {
      ElMessage.success('添加成功')
      dialogVisible.value = false
      resetSolutionForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('添加失败：', error)
    ElMessage.error('添加失败')
  }
}

async function handleSolutionConfirmEdit() {
  const { name, sort, banner, mbanner, thumbnail, description } = fullform.value
  const content = solutionEditorRef.value ? solutionEditorRef.value.getHtml() : ''

  if (!name || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整解决方案信息')
    return
  }

  const payload = {
    id: solutionEditingId.value,
    appId: queryParams.value.appId,
    name,
    sort: sort ?? 0,
    banner,
    mbanner,
    thumbnail,
    description,
    context: content
  }
  try {
    const res = await updateSolution(payload)
    if (res.code === 200) {
      ElMessage.success('修改成功')
      dialogVisible.value = false
      solutionIsEdit.value = false
      solutionEditingId.value = null
      resetSolutionForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('修改失败：', error)
    ElMessage.error('修改失败')
  }
}

async function handleSolutionEdit(id) {
  try {
    const res = await getSolutionDetail(id)
    if (res.code === 200) {
      const detail = res.data
      solutionEditingId.value = detail.id
      solutionIsEdit.value = true

      fullform.value.name = detail.name || ''
      fullform.value.sort = detail.sort ?? 0
      fullform.value.banner = detail.banner || ''
      fullform.value.mbanner = detail.mbanner || ''
      fullform.value.thumbnail = detail.thumbnail || ''
      fullform.value.description = detail.description || ''

      bannerFileList.value = detail.banner ? [{ name: 'banner', url: detail.banner }] : []
      mbannerFileList.value = detail.mbanner ? [{ name: 'mbanner', url: detail.mbanner }] : []
      thumbnailFileList.value = detail.thumbnail ? [{ name: 'thumbnail', url: detail.thumbnail }] : []

      dialogVisible.value = true
      await nextTick()
      if (solutionEditorRef.value) {
        solutionEditorRef.value.setHtml(detail.context || '')
      }
    }
  } catch (error) {
    console.error('获取解决方案详情失败：', error)
    ElMessage.error('获取解决方案详情失败')
  }
}

async function handleSolutionDelete(id) {
  try {
    const res = await deleteSolution(id)
    if (res.code === 200) {
      ElMessage.success('删除成功')
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('删除失败：', error)
    ElMessage.error('删除失败')
  }
}

function handleSolutionDialogClose() {
  solutionIsEdit.value = false
  solutionEditingId.value = null
  resetSolutionForm()
}

function resetSolutionForm() {
  fullform.value.name = ''
  fullform.value.sort = 0
  fullform.value.banner = ''
  fullform.value.mbanner = ''
  fullform.value.thumbnail = ''
  fullform.value.description = ''
  solutionEditorContent.value = ''
  bannerFileList.value = []
  mbannerFileList.value = []
  thumbnailFileList.value = []
}

// 硬件设备类型相关函数
async function handleDeviceTypeAdd() {
  deviceTypeIsEdit.value = false
  deviceTypeEditingId.value = null
  resetDeviceTypeForm()
  deviceTypeDialogVisible.value = true
  await nextTick()
  if (deviceTypeEditorRef.value) {
    deviceTypeEditorRef.value.setHtml('')
  }
}

async function handleDeviceTypeConfirmAdd() {
  const { name, sort, banner, mbanner, thumbnail, description } = deviceTypeForm.value
  const context = deviceTypeEditorRef.value ? deviceTypeEditorRef.value.getHtml() : ''

  if (!name || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整类型信息')
    return
  }

  const payload = {
    name,
    sort: sort ?? 0,
    banner,
    mbanner,
    thumbnail,
    description,
    context
  }
  try {
    const res = await addDeviceType(payload)
    if (res.code === 200) {
      ElMessage.success('添加成功')
      deviceTypeDialogVisible.value = false
      resetDeviceTypeForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('添加失败：', error)
    ElMessage.error('添加失败')
  }
}

async function handleDeviceTypeConfirmEdit() {
  const { name, sort, banner, mbanner, thumbnail, description } = deviceTypeForm.value
  const context = deviceTypeEditorRef.value ? deviceTypeEditorRef.value.getHtml() : ''

  if (!name || !banner || !mbanner || !thumbnail || !description) {
    ElMessage.warning('请填写完整类型信息')
    return
  }

  const payload = {
    id: deviceTypeEditingId.value,
    name,
    sort: sort ?? 0,
    banner,
    mbanner,
    thumbnail,
    description,
    context
  }
  try {
    const res = await updateDeviceType(payload)
    if (res.code === 200) {
      ElMessage.success('修改成功')
      deviceTypeDialogVisible.value = false
      deviceTypeIsEdit.value = false
      deviceTypeEditingId.value = null
      resetDeviceTypeForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('修改失败：', error)
    ElMessage.error('修改失败')
  }
}

async function handleDeviceTypeEdit(id) {
  try {
    const res = await getDeviceTypeDetail(id)
    if (res.code === 200) {
      const detail = res.data
      deviceTypeEditingId.value = detail.id
      deviceTypeIsEdit.value = true

      deviceTypeForm.value.name = detail.name || ''
      deviceTypeForm.value.sort = detail.sort ?? 0
      deviceTypeForm.value.banner = detail.banner || ''
      deviceTypeForm.value.mbanner = detail.mbanner || ''
      deviceTypeForm.value.thumbnail = detail.thumbnail || ''
      deviceTypeForm.value.description = detail.description || ''

      deviceTypeBannerFileList.value = detail.banner ? [{ name: 'banner', url: detail.banner }] : []
      deviceTypeMBannerFileList.value = detail.mbanner ? [{ name: 'mbanner', url: detail.mbanner }] : []
      deviceTypeThumbnailFileList.value = detail.thumbnail ? [{ name: 'thumbnail', url: detail.thumbnail }] : []

      deviceTypeDialogVisible.value = true
      await nextTick()
      if (deviceTypeEditorRef.value) {
        deviceTypeEditorRef.value.setHtml(detail.context || '')
      }
    }
  } catch (error) {
    console.error('获取类型详情失败：', error)
    ElMessage.error('获取类型详情失败')
  }
}

const handleDeviceTypeBannerUpload = async (options) => {
  const { file, onSuccess, onError } = options
  const formData = new FormData()
  formData.append('file', file)
  try {
    const res = await uploadImage(formData)
    if (res.code === 200) {
      file.url = res.data
      deviceTypeBannerFileList.value = [file]
      deviceTypeForm.value.banner = res.data
      onSuccess(res, file)
    } else {
      onError(res.message || '上传失败')
    }
  } catch (err) {
    onError(err)
  }
}

const handleDeviceTypeBannerRemove = () => {
  deviceTypeBannerFileList.value = []
  deviceTypeForm.value.banner = ''
}

const handleDeviceTypeMBannerUpload = async (options) => {
  const { file, onSuccess, onError } = options
  const formData = new FormData()
  formData.append('file', file)
  try {
    const res = await uploadImage(formData)
    if (res.code === 200) {
      file.url = res.data
      deviceTypeMBannerFileList.value = [file]
      deviceTypeForm.value.mbanner = res.data
      onSuccess(res, file)
    } else {
      onError(res.message || '上传失败')
    }
  } catch (err) {
    onError(err)
  }
}

const handleDeviceTypeMBannerRemove = () => {
  deviceTypeMBannerFileList.value = []
  deviceTypeForm.value.mbanner = ''
}

const handleDeviceTypeThumbUpload = async (options) => {
  const { file, onSuccess, onError } = options
  const formData = new FormData()
  formData.append('file', file)
  try {
    const res = await uploadImage(formData)
    if (res.code === 200) {
      file.url = res.data
      deviceTypeThumbnailFileList.value = [file]
      deviceTypeForm.value.thumbnail = res.data
      onSuccess(res, file)
    } else {
      onError(res.message || '上传失败')
    }
  } catch (err) {
    onError(err)
  }
}

const handleDeviceTypeThumbRemove = () => {
  deviceTypeThumbnailFileList.value = []
  deviceTypeForm.value.thumbnail = ''
}

function handleDeviceTypeDialogClose() {
  deviceTypeIsEdit.value = false
  deviceTypeEditingId.value = null
  resetDeviceTypeForm()
}

function resetDeviceTypeForm() {
  deviceTypeForm.value = {
    name: '',
    sort: 0,
    banner: '',
    mbanner: '',
    thumbnail: '',
    description: '',
    context: ''
  }
  deviceTypeEditorContent.value = ''
  deviceTypeBannerFileList.value = []
  deviceTypeMBannerFileList.value = []
  deviceTypeThumbnailFileList.value = []
}

async function handleDeviceTypeDelete(id) {
  try {
    const res = await deleteDeviceType(id)
    if (res.code === 200) {
      ElMessage.success('删除成功')
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('删除失败：', error)
    ElMessage.error('删除失败')
  }
}

// 设备 Banner2/Banner3 上传处理
const handleDeviceBanner2Upload = async (options) => {
  const { file, onSuccess, onError } = options
  const formData = new FormData()
  formData.append('file', file)
  try {
    const res = await uploadImage(formData)
    if (res.code === 200) {
      file.url = res.data
      deviceBanner2FileList.value = [file]
      fullform.value.banner2 = res.data
      onSuccess(res, file)
    } else {
      onError(res.message || '上传失败')
    }
  } catch (err) {
    onError(err)
  }
}
const handleDeviceBanner2Remove = () => {
  deviceBanner2FileList.value = []
  fullform.value.banner2 = ''
}
const handleDeviceBanner3Upload = async (options) => {
  const { file, onSuccess, onError } = options
  const formData = new FormData()
  formData.append('file', file)
  try {
    const res = await uploadImage(formData)
    if (res.code === 200) {
      file.url = res.data
      deviceBanner3FileList.value = [file]
      fullform.value.banner3 = res.data
      onSuccess(res, file)
    } else {
      onError(res.message || '上传失败')
    }
  } catch (err) {
    onError(err)
  }
}
const handleDeviceBanner3Remove = () => {
  deviceBanner3FileList.value = []
  fullform.value.banner3 = ''
}

// 硬件设备相关函数
async function handleDeviceAdd() {
  deviceIsEdit.value = false
  deviceEditingId.value = null
  resetDeviceForm()
  await fetchDeviceTypeList()
  await fetchDeviceList()
  dialogVisible.value = true
  await nextTick()
  if (deviceEditorRef.value) {
    deviceEditorRef.value.setHtml('')
  }
}

async function handleDeviceConfirmAdd() {
  const { name, deviceTypeId, sort, banner, banner2, banner3, thumbnail, description, deviceIds } = fullform.value
  const content = deviceEditorRef.value ? deviceEditorRef.value.getHtml() : ''

  if (!name || !banner || !thumbnail || !description) {
    ElMessage.warning('请填写完整设备信息')
    return
  }

  const payload = {
    appId: queryParams.value.appId,
    name,
    deviceTypeId,
    sort: sort ?? 0,
    banner,
    banner2,
    banner3,
    thumbnail,
    description,
    deviceIds: (deviceIds || []).join(','),
    context: content
  }
  try {
    const res = await addDevice(payload)
    if (res.code === 200) {
      ElMessage.success('添加成功')
      dialogVisible.value = false
      resetDeviceForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('添加失败：', error)
    ElMessage.error('添加失败')
  }
}

async function handleDeviceConfirmEdit() {
  const { name, deviceTypeId, sort, banner, banner2, banner3, thumbnail, description, deviceIds } = fullform.value
  const content = deviceEditorRef.value ? deviceEditorRef.value.getHtml() : ''

  if (!name || !banner || !thumbnail || !description) {
    ElMessage.warning('请填写完整设备信息')
    return
  }

  const payload = {
    id: deviceEditingId.value,
    appId: queryParams.value.appId,
    name,
    deviceTypeId,
    sort: sort ?? 0,
    banner,
    banner2,
    banner3,
    thumbnail,
    description,
    deviceIds: (deviceIds || []).join(','),
    context: content
  }
  try {
    const res = await updateDevice(payload)
    if (res.code === 200) {
      ElMessage.success('修改成功')
      dialogVisible.value = false
      deviceIsEdit.value = false
      deviceEditingId.value = null
      resetDeviceForm()
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('修改失败：', error)
    ElMessage.error('修改失败')
  }
}

async function handleDeviceEdit(id) {
  try {
    const res = await getDeviceDetail(id)
    if (res.code === 200) {
      const detail = res.data
      deviceEditingId.value = detail.id
      deviceIsEdit.value = true

      fullform.value.name = detail.name || ''
      fullform.value.deviceTypeId = detail.deviceTypeId ?? null
      fullform.value.sort = detail.sort ?? 0
      fullform.value.banner = detail.banner || ''
      fullform.value.banner2 = detail.banner2 || ''
      fullform.value.banner3 = detail.banner3 || ''
      fullform.value.thumbnail = detail.thumbnail || ''
      fullform.value.description = detail.description || ''
      fullform.value.deviceIds = detail.deviceIds ? detail.deviceIds.split(',').filter(Boolean).map(Number) : []

      bannerFileList.value = detail.banner ? [{ name: 'banner', url: detail.banner }] : []
      deviceBanner2FileList.value = detail.banner2 ? [{ name: 'banner2', url: detail.banner2 }] : []
      deviceBanner3FileList.value = detail.banner3 ? [{ name: 'banner3', url: detail.banner3 }] : []
      thumbnailFileList.value = detail.thumbnail ? [{ name: 'thumbnail', url: detail.thumbnail }] : []

      await fetchDeviceTypeList()
      await fetchDeviceList()
      dialogVisible.value = true
      await nextTick()
      if (deviceEditorRef.value) {
        deviceEditorRef.value.setHtml(detail.context || '')
      }
    }
  } catch (error) {
    console.error('获取设备详情失败：', error)
    ElMessage.error('获取设备详情失败')
  }
}

async function handleDeviceDelete(id) {
  try {
    const res = await deleteDevice(id)
    if (res.code === 200) {
      ElMessage.success('删除成功')
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('删除失败：', error)
    ElMessage.error('删除失败')
  }
}

function handleDeviceDialogClose() {
  deviceIsEdit.value = false
  deviceEditingId.value = null
  resetDeviceForm()
}

function resetDeviceForm() {
  fullform.value.name = ''
  fullform.value.deviceTypeId = null
  fullform.value.sort = 0
  fullform.value.banner = ''
  fullform.value.banner2 = ''
  fullform.value.banner3 = ''
  fullform.value.thumbnail = ''
  fullform.value.description = ''
  fullform.value.deviceIds = []
  deviceEditorContent.value = ''
  bannerFileList.value = []
  deviceBanner2FileList.value = []
  deviceBanner3FileList.value = []
  thumbnailFileList.value = []
}

async function fetchDeviceTypeList() {
  try {
    const res = await getDeviceTypeList({ appId: queryParams.value.appId })
    if (res.code === 200) {
      deviceTypeList.value = res.data || []
    }
  } catch (error) {
    console.error('获取设备类型列表失败：', error)
  }
}

async function fetchDeviceList() {
  try {
    const res = await getDevicePage({ appId: queryParams.value.appId, current: 1, size: 1000 })
    deviceList.value = res.data?.records || []
  } catch (error) {
    console.error('获取设备列表失败：', error)
  }
}

function isVideoFile(url) {
  if (!url) return false
  return /\.(mp4|webm|ogg|mov|avi)(\?|$)/i.test(url)
}

function getDeviceTypeName(id) {
  if (id == null) return '-'
  const found = deviceTypeList.value.find(item => item.id === id)
  return found ? found.name : id
}

function resetCaseForm() {
  fullform.value.name = ''
  fullform.value.sort = 0
  fullform.value.banner = ''
  fullform.value.mbanner = ''
  fullform.value.thumbnail = ''
  fullform.value.description = ''
  caseEditorContent.value = ''
  bannerFileList.value = []
  mbannerFileList.value = []
  thumbnailFileList.value = []
}

async function handleDeleteNews(id) {
  try {
    const res = await deleteNews(id)
    if (res.code === 200) {
      ElMessage.success('删除成功')
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('删除失败：', error)
    ElMessage.error('删除失败')
  }
}

async function handleSetNewsTop(id) {
  try {
    const res = await setNewsTop(id)
    if (res.code === 200) {
      ElMessage.success('置顶成功')
      tableData.value = []
      Detailgender()
    }
  } catch (error) {
    console.error('置顶失败：', error)
    ElMessage.error('置顶失败')
  }
}

function handleNewsDialogClose() {
  isEdit.value = false
  editingId.value = null
  resetNewsForm()
}

function resetNewsForm() {
  fullform.value.name = ''
  fullform.value.newsTime = ''
  fullform.value.banner = ''
  fullform.value.mbanner = ''
  fullform.value.thumbnail = ''
  fullform.value.description = ''
  editorContent.value = ''
  bannerFileList.value = []
  mbannerFileList.value = []
  thumbnailFileList.value = []
}

function formatNewsTime(time) {
  if (!time) return ''
  try {
    const d = new Date(time)
    if (isNaN(d.getTime())) return time
    const y = d.getFullYear()
    const m = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    const h = String(d.getHours()).padStart(2, '0')
    const min = String(d.getMinutes()).padStart(2, '0')
    return `${y}-${m}-${day} ${h}:${min}`
  } catch {
    return time
  }
}

function additem() {
  fullform.value.form.push({ type: '', value: '' ,fileList:[]})
}
function minbtn() {
  fullform.value.form.pop()
}

// const customUpload = async (options, item) => {
//   const { file, onSuccess, onError } = options;
//   const formData = new FormData();
//   formData.append('file', file);

//   try {
//     const res = await uploadImage(formData);
//     if (res.code === 200) {
//       const url = res.data;
//       file.url = url;

//       // 设置 item.value
//       if (item.type === '单图片') {
//         item.value = url;
//         item.fileList = [file];
//       } else if (item.type === '多图片') {
//         item.value += url + '\n';
//         item.fileList.push(file);
//       }

//       onSuccess(res, file); // 通知上传成功
//     } else {
//       onError(res.message || '上传失败');
//     }
//   } catch (err) {
//     onError(err);
//   }
// };
const customUpload = async (options, item) => {
  const { file, onSuccess, onError } = options;
  const formData = new FormData();
  formData.append('file', file);

  try {
    const res = await uploadImage(formData);
    if (res.code === 200) {
      const url = res.data;
      file.url = url; // Element Plus 依赖 file.url 进行回显

      if (item.type === '单图片') {
        item.value = url;
        item.fileList = [file];
      } else if (item.type === '多图片') {
        item.value += (item.value ? ';' : '') + url;
        item.fileList.push(file);
      } else if (item.type === '视频') {
        item.value = url;
        item.fileList = [file];
      }

      onSuccess(res, file);
    } else {
      onError(res.message || '上传失败');
    }
  } catch (err) {
    onError(err);
  }
};


const handleRemove = (file, item) => {
  // 获取当前图片链接
  const removedUrl = file.url || (file.response && file.response.data);

  if (!removedUrl) return;

  if (item.type === '单图片') {
    // 单图：直接清空
    item.value = '';
    item.fileList = [];
  } else if (item.type === '多图片') {
    // 多图：从 value 和 fileList 中移除这张图
    const urls = item.value.split(';').filter(url => url !== removedUrl);
    item.value = urls.join(';');

    item.fileList = item.fileList.filter(f => {
      return f.url !== removedUrl && (f.response?.data !== removedUrl);
    });
  }
};
const beforeVideoUpload = (file) => {
  const isVideo = file.type.startsWith('video/');
  const isLt100M = file.size / 1024 / 1024 < 100;//限制视频大小

  if (!isVideo) {
    ElMessage.error('上传文件只能是视频格式!');
  }
  if (!isLt100M) {
    ElMessage.error('视频大小不能超过 100MB!');
  }
  return isVideo && isLt100M;
};
//删除
function detaildelete(index) {
  console.log(index);
  fullform.value.form.splice(index, 1);
  try {
    deleteItem(index)
    tableData.value = [];
    Detailgender()
    ElMessage.success('删除成功');
  } catch (error) {
    ElMessage.error('删除失败');
  }
 
}
const addFeature = (item) => {
  if (!item.features) {
    item.features = [];
  }
  item.features.push({
    title: '',
    valueList: ''
  });
};

const removeFeature = (item, index) => {
  if (item.features && item.features.length > index) {
    item.features.splice(index, 1);
  }
};
</script>

<style scoped>
/* 穿透设置表格样式*/
/* 强制固定表格布局 */
:deep(.el-table) {
  table-layout: fixed !important;
}

/* 统一行高 */
:deep(.el-table__body tr) {
  height: 60px !important; /* 统一行高 */
  
  /* 所有单元格继承行高 */
  td {
    height: inherit !important;
    vertical-align: middle !important;
    padding: 5px 8px !important;
    box-sizing: border-box !important;
  }
}
:deep(.el-table__cell.text-column) {
  .cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 50px !important; /* 60px - 上下padding */
  }
}
:deep(.el-table__cell.multiline-column) {
  .cell {
    display: -webkit-box;
    -webkit-line-clamp: 3; /* 显示行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.4em;
    max-height: calc(1.4em * 3); /* 行高×行数 */
    word-break: break-all;
  }
}
:deep(.el-table__cell.image-column) {
  img {
    max-height: 50px; /* 小于行高留出边距 */
    max-width: 100%;
    display: block;
    margin: 0 auto;
  }
}
:deep(.el-table__cell.action-column) {
  .cell {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 5px;
    height: 100%;
    
    .el-button {
      margin: 0;
      padding: 5px 8px;
      height: auto;
    }
  }
}

.backend{
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100vh;
}
.side{
  width: 16%;
  height: 100%;
}
::v-deep(.el-tabs) {
  height: 100% !important;
  width: 100% !important;
  padding: 0 !important;
  margin: 0 !important;
}
.main-con{
  width: 88%;
  height: 100%;
}
/* .pro-con, .new-con, .about-con, .sol-con, .cont-con{
  overflow: hidden;
  width: 88%;
  height: 80%;
  margin: 1em auto;
} */
.el-table__inner-wrapper{
  height: 80%;
}
.demo-tabs{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
/* 修改标签高度 */
::v-deep(.el-tabs--left .el-tabs__item) {
  display: flex;
  width: 100% !important;
  align-items: center;     
  justify-content: center;
  height: 5em;
  line-height:5em;
  text-align: center;
}
.pro-top, .sol-top, .cont-top{
  display: flex;
  justify-content: flex-end;
}
.box-form{
  display: flex;
  justify-content: space-between;
}
.el-form-item{
  width: 50% !important;
}
.addbtn{
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.el-table-column{
  text-align: center!important;
}

::v-deep .el-table .el-table__body .el-table__cell[data-col="value"] {
  text-align: center !important;
}
.yingyong{
  width: 100%;
  height: 3em;
  display: flex;
  justify-content: space-between;
}
.yingyong>.el-select{
  width:8%;
  height: 3em;
  margin-left: 6em;
}
.search{
  margin-right:6em ;
  height: 3em;
}
.table-wrap{
  /* height: 80%!important;  */
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.core-feature-editor {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 12px;
  background-color: #fafafa;
}

.feature-item {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  background-color: white;
}

.feature-list {
  margin-bottom: 12px;
}

/* 新闻表单内 el-row 中的 el-form-item 恢复自动宽度 */
.news-form .el-form-item {
  width: auto !important;
}

/* WangEditor 全屏时 z-index 需高于弹窗 */
:deep(.w-e-full-screen-container) {
  z-index: 9999 !important;
}

</style>
